import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import PreShiftRitual from "@/components/PreShiftRitual";
import Manifesto from "@/components/Manifesto";
import ModulesBento from "@/components/ModulesBento";
import PricingBlock from "@/components/PricingBlock";
import { FAQSection } from "@/components/FAQSection";
import BooksSection from "@/components/BooksSection";
import AuthorSection from "@/components/AuthorSection";
import { FounderPromise } from "@/components/FounderPromise";
import Testimonials from "@/components/Testimonials";
import { GraduateWall } from "@/components/GraduateWall";
import { StoryRoomBridge } from "@/components/StoryRoomBridge";
import B2BSection from "@/components/B2BSection";

export default function Landing() {
  return (
    <main>
      <Hero />
      <EditorialMarquee />
      <PreShiftRitual />
      <Manifesto />
      <ModulesBento />
      <PricingBlock />
      <FAQSection />
      <BooksSection />
      <AuthorSection />
      <FounderPromise />
      <Testimonials />
      <GraduateWall />
      <StoryRoomBridge />
      <B2BSection />
    </main>
  );
}
